export const formatBirthday = (birthday?: string) => {
  if (!birthday) return ""; // undefined/null 처리

  // 이미 "MM.DD" 형식이면 그대로 리턴
  if (birthday.includes(".")) return birthday;

  // "MMDD" 형식이면
  if (birthday.length === 4) {
    const month = birthday.slice(0, 2);
    const day = birthday.slice(2, 4);
    return `${month}.${day}`;
  }

  return birthday; // 그 외 케이스는 그대로
};
